export const isArSupported = () => {
    if (typeof window === 'undefined') {
        return false;
    }

    const isSecure =
        window.isSecureContext ||
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1';

    return isSecure && !!navigator.mediaDevices?.getUserMedia;
};

export const getArStartErrorMessage = (error?: unknown) => {
    if (error instanceof DOMException && (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError')) {
        return 'Permita o uso da camera para continuar com a experiencia AR.';
    }

    return 'Nao foi possivel iniciar a sessao AR neste aparelho.';
};
